import axios from "axios";
import { backendAPI } from "../../../config/config";
import { FilterPoint, Point} from "../types/types";
import { ResponseAPIWithPagination } from "../../../common/types/API.types";

// Le backend accepte uniquement des timestamps RFC3339 (YYYY-MM-DDTHH:MM:SSZ)
// ou des Flux durations pour les bornes start/stop (validation stricte côté API).
const toRFC3339 = (date: Date): string => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

const formatDateForAPI = (dateISO: string | null | undefined): string => {
    if (!dateISO) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateISO)) {
        return `${dateISO}T00:00:00Z`;
    }
    const date = new Date(dateISO);
    if (isNaN(date.getTime())) return "";
    return toRFC3339(date);
};

// Recule d'un jour et d'une heure pour que la fenêtre inclue le jour 1
// (commence à 23:00 UTC la veille).
const formatStartDateForAPI = (dateISO: string | null | undefined): string => {
    if (!dateISO) return "";
    const base = /^\d{4}-\d{2}-\d{2}$/.test(dateISO)
        ? new Date(dateISO + 'T00:00:00.000Z')
        : new Date(dateISO);
    if (isNaN(base.getTime())) return "";
    base.setUTCDate(base.getUTCDate() - 1);
    base.setUTCHours(base.getUTCHours() - 1);
    return toRFC3339(base);
};

const baseUrl = backendAPI 
export const getPoints = async (filter?: FilterPoint) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow+"&aggregateFunction=max&difference=true&measurement=device_frmpayload_data_consumption,device_frmpayload_data_data_consumption&filters=device_name="+counter_id
    return  (await axios.get<Point[]>(`${baseUrl}/minigrid?${params}`, { params: filter })).data
}

export const getActivePowerPointSingleCounter = async (filter?: FilterPoint) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/active_power?${params}`, { params: filter })).data
}

export const getCreditSingleCounter = async (filter?: FilterPoint) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/credit?${params}`, { params: filter })).data
}

export const getLastCreditSingleCounter = async (filter?: FilterPoint) => {


    const counter_id = filter?.device_name


    const params = "last=true"
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/credit?${params}`, { params: filter })).data
}

export const getFrequencySingleCounter = async (filter?: FilterPoint) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/frequency?${params}`, { params: filter })).data
}

export const getVoltageSingleCounter = async (filter?: FilterPoint) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/voltage?${params}`, { params: filter })).data
}

export const getLastVoltageSingleCounter = async (filter?: FilterPoint) => {
    const counter_id = filter?.device_name

    const params = "last=true"
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/voltage?${params}`, { params: filter })).data
}

export const getCurrentSingleCounter = async (filter?: FilterPoint) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/current?${params}`, { params: filter })).data
}

export const getConsumptionSingleCounter = async (filter?: FilterPoint) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/consumption?${params}`, { params: filter })).data
}

export const getConsumptionIndexSingleCounter = async (filter?: FilterPoint) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/consumption_index?${params}`, { params: filter })).data
}

export const getLastConsumptionSingleCounter = async (filter?: FilterPoint) => {
    const counter_id = filter?.device_name

    const params = "last=true"
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/consumption?${params}`, { params: filter })).data
}

export const getLastConsumptionIndexSingleCounter = async (filter?: FilterPoint) => {
    const counter_id = filter?.device_name

    const params = "last=true"
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/consumption_index?${params}`, { params: filter })).data
}

export const getBigConsummersRanking = async (filter?: FilterPoint) => {

    const params = "limit=10&orderBy=-consumption"
    return  (await axios.get<ResponseAPIWithPagination<Point>>(`${baseUrl}/analytics/counters?${params}`, { params: filter })).data

}

export const getLastHeartbeatSingleCounter = async (filter?: FilterPoint, device_name?: string) => {
    const counter_id = filter?.device_name || device_name
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/last_heartbeat`)).data
}

export const getNBTails = async (device_name: string) => {

    return  (await  axios.get<Point[]>(`${baseUrl}/analytics/${device_name}/nb_tails`)).data
}

export const getNBCuts = async (device_name: string) => {
    return  (await  axios.get<Point[]>(`${baseUrl}/analytics/${device_name}/nb_cuts`)).data
}

export const getLastLogs = async (device_name: string, limit: number = 10) => {
    return  (await  axios.get<Point[]>(`${baseUrl}/analytics/${device_name}/last_logs?limit=${limit}`)).data
}

export const getPowerFactor = async (filter?: FilterPoint, device_name?: string) => {
    const startDate = formatStartDateForAPI(filter?.startDate) || "2023-05-01T00:00:00Z"
    const stopDate = formatDateForAPI(filter?.stopDate) || "2024-05-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const counter_id = filter?.device_name || device_name
    const aggregateWindow = filter?.aggregateWindow || "1mo"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return  (await  axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/power_factor?${params}`, { params: filter })).data
}

export const getLastPowerFactor = async (filter?: FilterPoint) => {
    const counter_id = filter?.device_name

    const params = "last=true"
    return  (await axios.get<Point[]>(`${baseUrl}/analytics/${counter_id}/power_factor?${params}`, { params: filter })).data
}

export type RelayStatusResponse = {
    meter_id: string
    relay_on: boolean
    updated_at: string
}

export const getRelayStatus = async (deviceId: string): Promise<RelayStatusResponse> => {
    return (await axios.get<RelayStatusResponse>(`${baseUrl}/meters/${deviceId}/relay-status`)).data
}

const dataAPI = {
    getPoints,
    getActivePowerPointSingleCounter,
    getCreditSingleCounter,
    getFrequencySingleCounter,
    getVoltageSingleCounter,
    getCurrentSingleCounter,
    getLastCreditSingleCounter,
    getConsumptionSingleCounter,
    getLastConsumptionSingleCounter,
    getLastVoltageSingleCounter,
    getBigConsummersRanking,
    getConsumptionIndexSingleCounter,
    getLastHeartbeatSingleCounter,
    getNBTails,
    getNBCuts,
    getLastLogs,
    getPowerFactor,
    getLastPowerFactor,
    getLastConsumptionIndexSingleCounter
}



export default dataAPI